import { render } from "./SyncWordsSettingsPanel.vue?vue&type=template&id=0df48474"
import script from "./SyncWordsSettingsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncWordsSettingsPanel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/SyncWordsSettingsPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0df48474"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0df48474', __exports__)) {
    api.reload('0df48474', __exports__)
  }
  
  module.hot.accept("./SyncWordsSettingsPanel.vue?vue&type=template&id=0df48474", () => {
    api.rerender('0df48474', render)
  })

}


export default __exports__